import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

const base = createBaseStoreRefactor({
  endpoint: "/api/v1/deadline_categories",
  name: "DeadlineCategoriesStoreRefactor",
  objectName: "Deadline category",
  enableCache: true,
  actionCableChannel: null,
  infiniteLoading: false,
});

export const useDeadlineCategoriesStoreRefactor = defineStore(
  "deadlineCategoriesRefactor",
  {
    ...base,
    getters: {
      ...base.getters,
      categories: (state) => state.data || [],
      getById: (state) => (id) => state.data.find((c) => c.id == id),
    },
    actions: {
      ...base.actions,
    },
  },
);
